export default "__VITE_ASSET__oJhq4ydM__"